/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { Segmentation } from '../../../../mol-data/int';
import { StructureElement } from '../../../../mol-model/structure/structure/element';
import { StructureProperties as P } from '../../structure';
import { Structure } from '../../structure/structure';
import { StructureSelection } from '../selection';
import { BondType } from '../../model/types';
import { Bundle } from '../../structure/element/bundle';
export function defaultBondTest(ctx) {
    return BondType.isCovalent(ctx.atomicBond.type);
}
export function atomicSequence() {
    return function query_atomicSequence(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = StructureElement.Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Unit.Kind.Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (P.entity.type(l) !== 'polymer')
                continue;
            var residuesIt = Segmentation.transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
            var residueCount = 0;
            while (residuesIt.hasNext) {
                residueCount++;
                residuesIt.move();
            }
            if (residueCount < 8)
                continue;
            units.push(unit);
        }
        return StructureSelection.Singletons(inputStructure, Structure.create(units, { parent: inputStructure }));
    };
}
export function water() {
    return function query_water(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = StructureElement.Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Unit.Kind.Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (P.entity.type(l) !== 'water')
                continue;
            units.push(unit);
        }
        return StructureSelection.Singletons(inputStructure, Structure.create(units, { parent: inputStructure }));
    };
}
export function atomicHet() {
    return function query_atomicHet(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = StructureElement.Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Unit.Kind.Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (P.entity.type(l) === 'water')
                continue;
            if (P.entity.type(l) === 'polymer') {
                var residuesIt = Segmentation.transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
                var residueCount = 0;
                while (residuesIt.hasNext) {
                    residueCount++;
                    residuesIt.move();
                }
                if (residueCount >= 8)
                    continue;
            }
            units.push(unit);
        }
        return StructureSelection.Singletons(inputStructure, Structure.create(units, { parent: inputStructure }));
    };
}
export function spheres() {
    return function query_spheres(ctx) {
        var inputStructure = ctx.inputStructure;
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 1 /* Unit.Kind.Spheres */)
                continue;
            units.push(unit);
        }
        return StructureSelection.Singletons(inputStructure, Structure.create(units, { parent: inputStructure }));
    };
}
export function bundleElementImpl(groupedUnits, ranges, set) {
    return {
        groupedUnits: groupedUnits,
        ranges: ranges,
        set: set
    };
}
export function bundleGenerator(elements) {
    return function query_bundleGenerator(ctx) {
        var bundle = {
            hash: ctx.inputStructure.hashCode,
            elements: elements
        };
        return StructureSelection.Sequence(ctx.inputStructure, [Bundle.toStructure(bundle, ctx.inputStructure)]);
    };
}
